import React from 'react';
export function Footer() {
  return <footer className="bg-[#2E4F48] py-6 md:py-8 px-4 text-center border-t border-[#1C3B36]" data-id="element-154" data-mp="32wd2cf6gdjt0">
      <div className="container mx-auto max-w-3xl" data-id="element-155" data-mp="3ggtx2ezk5d3n">
        <h3 className="text-xl font-serif font-bold text-[#E8E0D3] mb-4 tracking-wider" data-id="element-156" data-mp="32o48q3wk3w3d">
          🧬 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>

        <p className="text-[#E8E0D3] text-sm md:text-base leading-relaxed mb-8 max-w-2xl mx-auto opacity-90" data-id="element-157" data-mp="36pz9n7aks7gm">
          El sistema de formación en biodescodificación N°1 para Argentina.
          Porque entender el lenguaje de tu cuerpo no debería postergarse por
          falta de una formación a la altura.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-10 text-sm text-[#C2683D] font-medium" data-id="element-158" data-mp="3lggfd2u8tjjb">
          <a href="mailto:academiaholisticaargentina@gmail.com" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-159" data-mp="29ynmjnzj5bfl">
            📧 academiaholisticaargentina@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-160" data-mp="3la28msb12zu6">
            📲 Instagram: @academiaholisticaargentina
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-161" data-mp="3v9b1fhu5q8ey">
            📘 Facebook: Academia Holística Argentina
          </a>
        </div>

        <div className="text-xs text-[#E8E0D3] opacity-70 space-y-4" data-id="element-162" data-mp="817d85ghpotj">
          <p data-id="element-163" data-mp="32w45wy0ricd">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p className="font-serif italic text-sm" data-id="element-164" data-mp="cv1rgtdbtbl8">
            🧬 "El cuerpo habla. Aprendé a escucharlo."
          </p>
        </div>
      </div>
    </footer>;
}